
import OffersAutocomplete from "./OffersAutocomplete.js";
import SearchJobsFilter   from "./SearchJobsFilter.js";

export default class OffersResultsWatch {

    constructor(){

        // for First load (v/ php)
        let searchParams = this.get_url_params( window.location.search ) ;

        if( this.is_valid_url_params( searchParams ) ){
            this.offers_store_searchParams( searchParams );
        }

        // - -

        // for ajax call
        window.addEventListener('locationchange', ( e )=> {

            // e.preventDefault();
            let urlParams = this.get_url_params( window.location.search ) ;
            if( this.is_valid_url_params( urlParams ) ){
                this.offers_results_ajax_refresh();
            }

        }) ;
    }

    // - - - - - - - - - - - - - - - - - - - - - - - -


    get_minimal_object(){

        let params = {};

        params.jobQ = {}
        params.jobQ.title = '';
        params.jobQ.location = '';

        params.jobP = {}
        params.jobP.more  = '0';
        params.jobP.pages = '1';

        params.jobF = {}
        params.jobF.sectors =[] ;
        params.jobF.regions =[] ;


        return params ;

    }


    get_url_params( search_url ){
        return new URLSearchParams( search_url ) ;
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
    // params de type URLSearchParams

    is_valid_url_params( urlParams ){

        if( ! urlParams.has('jobQ[title]') && ! urlParams.has('jobP[pages]') ){
            return false ;
        }


        // disable required title
        /*
		if( ! urlParams.has('jobQ[title]') || '' == urlParams.get('jobQ[title]') ){
			return false ;
		}
		*/

        // disable required location
        /*
		if( ! urlParams.has('jobQ[location]') || '' == urlParams.get('jobQ[location]') ){
			return false ;
		}
		 */


        return true ;
    }




    offers_store_searchParams( searchParams ){

        // Params
        let params = this.get_params_obj_from_searchParams( searchParams ) ;
        window.whodunit.theme.jobs.searchParams = params ;

    }


    get_params_obj_from_searchParams( searchParams ){

        let params = this.get_minimal_object() ;


        // override
        try {

            let entries = searchParams.entries() ;

            searchParams.forEach( ( v, k ) => {

                // ex :  jobQ[title] -> params.jobQ.title

                // la clé est un array ?
                const the_key = k ;
                const regex = /\[\]/g;
                const found = the_key.match(regex);

                const split = k.split("[");
                let part = split[0];
                let slug = split[1];

                // single value
                if( ! Array.isArray(found) ){

                    slug = slug.replace("]", "");
                    if( ! params[ part ] ){ params[ part ] = {} ; }
                    params[ part ][ slug ] = v ;


                    // tableau
                }else{

                    slug = slug.replace("]", "");

                    if( ! params[ part ] ){ params[ part ] = {} ; }

                    if( params[ part ][ slug ] ){
                        let current_value = params[ part ][ slug ] ;
                        current_value.push( v );
                        params[ part ][ slug ] = current_value ;
                    }else{
                        params[ part ][ slug ] = [ v ] ;
                    }

                }


            });

        } catch (exceptionVar) { }

        // - -

        return params ;
    }




    offers_results_ajax_refresh(){

        // - - - - - - - - - - - - - - - - - - - -

        // App state

        /*
		let currentItems = 0 ;
		let cards = jQuery('.search-results-grid .entry-card--offer') ;
		if( cards.length > 0 ){ currentItems = cards.length ; console.log(cards.length) ; }
		 */

        let needRefresh = [] ;

        // compare param pour voir les parties a refresh
        let searchParams   = this.get_url_params( window.location.search ) ;

        // jobQ has change ?
        let params         = this.get_params_obj_from_searchParams( searchParams ) ;
        let previousParams = window.whodunit.theme.jobs.searchParams ;

        /**
         * Refresh tests
         */
        let needSearchFormRefresh = false ;
        let needLoadMore = false ;

        // search form ?
        try {
            if( ( previousParams.jobQ.title    != params.jobQ.title )   ||  ( previousParams.jobQ.location != params.jobQ.location ) ){
                needSearchFormRefresh = true ;
            }
        } catch (error) { }


        // refresh count
        if( needSearchFormRefresh ){
            needRefresh.push( 'resultsCount' ) ;
        }

        //fore order refrsh
        let doOrderRefresh = false ;


        try {
            if( ( previousParams.jobO.order != params.jobO.order ) ){
                doOrderRefresh = true ;
            }
        } catch (error) { doOrderRefresh = true ; }


        // force filters refresh
        let doFilterRefresh = false ;
        try {
            if(
                ( previousParams.jobF.contracts != params.jobF.contracts ) ||
                ( previousParams.jobF.regions   != params.jobF.regions )   ||
                ( previousParams.jobF.sectors   != params.jobF.sectors )

            ){ doFilterRefresh = true ; }

        } catch (error) { doFilterRefresh = true ; }


        // result if doFilterRefresh
        /// if( doFilterRefresh ){}


        // refresh filters
        if( needSearchFormRefresh || doFilterRefresh ){
            needRefresh.push( 'filterContracts' ) ;
            needRefresh.push( 'filterSectors' ) ;
            needRefresh.push( 'filterRegions' ) ;
        }

        // reresh order
        if( doOrderRefresh ) {
            needRefresh.push( 'filterOrder' ) ;
        }


        // is new query
        let isNewQuery = false ;
        if( needSearchFormRefresh ){
            isNewQuery = true ;
        }


        // - -


        // always refresh laod more
        // TODO : optim selon le conext de la demande, pê pas besoin de refresh...
        needRefresh.push( 'loadMore' ) ;

        // always refresh result
        // TODO : optim selon le conext de la demande, pê pas besoin de refresh...
        needRefresh.push( 'resultsCount' ) ;

        // refresh filters ?

        // ok -> store
        this.offers_store_searchParams( searchParams );


        // refresh <3
        // certaines parties doivent être refresh avant le call ajax (perf, ux)
        if( needSearchFormRefresh ){
            let jobQ = window.whodunit.theme.jobs.searchParams.jobQ ;
            jQuery('#jobQ__title').val( jobQ.title.toString() );
            jQuery('#jobQ__location').val( jobQ.location.toString() );
        }


        // - - - - - - - - - - - - - - - - - - - -

        // deja une grid ou 1er call ?
        let isFirst = 'true' ;
        if( jQuery('.who-block-offers-results__results').length > 0 ){
            isFirst = 'false' ;
        }

        // ajout des compteurs et des filtres
        if( 'true' === isFirst  ){
            // reresh first search form
            needRefresh.push( 'searchFormBlock' ) ;
        }


        // - - - - - - - - - - - - - - - - - - - -

        // Ajax

        // console.log(needRefresh);
        // console.log( window.whodunit.theme.jobs.searchParams ) ;

        let state = {
            'action'           : 'update_jobs_search',
            'nonce'            : DATA.nonce_update_jobs_search,
            'params'           : window.whodunit.theme.jobs.searchParams,
            'first'            : isFirst,
            'refresh'          : needRefresh,
            // 'currentItems'     : currentItems,
        };

        // console.log( state ) ;

        // - -

        jQuery( 'body' ).addClass( 'is--ajax-search-job-loading' ) ;



        // - -

        jQuery.post(
            DATA.ajax_url,
            state,
            // function( response ) {}
        )
            .done( function( data, textStatus, jqXHR ){

                /**
                 * refresh ?
                 */

                // console.log(data.refresh);

                if( data.refresh.indexOf( 'loadMore' ) > -1 ){
                    jQuery('.search-load-more').replaceWith( data.loadMore );
                }

                if( data.refresh.indexOf( 'resultsCount' ) > -1 ){
                    jQuery('.search-results-count').replaceWith( data.resultsCount );
                }

                if( data.refresh.indexOf( 'filterSectors' ) > -1 ){
                    jQuery('#job-filter--sectors').empty().append( data.filterSectors );
                }

                if( data.refresh.indexOf( 'filterRegions' ) > -1 ){
                    jQuery('#job-filter--regions').empty().append( data.filterRegions );
                }

                if( data.refresh.indexOf( 'filterContracts' ) > -1 ){
                    jQuery('#job-filter--contracts').empty().append( data.filterContracts );
                }

                if( data.refresh.indexOf( 'filterOrder' ) > -1 ){
                    // jQuery('#job-filter--order').empty().append( data.filterOrder );
                    jQuery('.search-results-filter--order .search-results-filter__button-text').empty().text( data.filterOrderLabel );

                }

                // - - -

                if( data.refresh.indexOf( 'searchFormBlock' ) > -1 ){
                    jQuery('.who-block-search-form-offers').replaceWith( data.searchFormBlock );
                    new OffersAutocomplete();

                    let jobQ = window.whodunit.theme.jobs.searchParams.jobQ ;
                    jQuery('#jobQ__title').val( jobQ.title.toString() );
                    jQuery('#jobQ__location').val( jobQ.location.toString() );

                    new SearchJobsFilter();

                }


                /**
                 * Results classique
                 */
                let resultsNODE = jQuery('.who-block-offers-results__results') ;

                if( ( 0 === resultsNODE.length ) && ( '' != data.resultsBlock ) ){
                    jQuery('.who-block-search-form-offers').after( data.resultsBlock );
                }else{
                    resultsNODE.empty().html( data.resultsGrid ) ;
                }

            })
            // .fail(function (jqXHR, textStatus, errorThrown) {})
            .always(function () {
                jQuery( 'body' ).removeClass( 'is--ajax-search-job-loading' ) ;
            });


    }



    // - - end
}

